import * as React from "react";
import { SVGProps } from "react";
export const HeartFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 16.6283C9.81944 16.6283 9.64236 16.5971 9.46875 16.5346C9.29514 16.4721 9.13194 16.3714 8.97917 16.2325L7.75 15.1075C6.23611 13.7603 4.89931 12.4443 3.73958 11.1596C2.57986 9.87484 2 8.47554 2 6.96165C2 5.73943 2.41667 4.71859 3.25 3.89915C4.08333 3.07971 5.11806 2.66998 6.35417 2.66998C7.0625 2.66998 7.73264 2.81929 8.36458 3.1179C8.99653 3.41651 9.54167 3.84359 10 4.39915C10.4861 3.84359 11.0382 3.41651 11.6562 3.1179C12.2743 2.81929 12.9375 2.66998 13.6458 2.66998C14.8819 2.66998 15.9167 3.07971 16.75 3.89915C17.5833 4.71859 18 5.73943 18 6.96165C18 8.47554 17.4201 9.87484 16.2604 11.1596C15.1007 12.4443 13.7639 13.7603 12.25 15.1075L11.0208 16.2325C10.8681 16.3714 10.7049 16.4721 10.5312 16.5346C10.3576 16.5971 10.1806 16.6283 10 16.6283Z"
            fill="currentColor"
        />
    </svg>
);
HeartFillIcon.displayName = "HeartFillIcon";
